import sendIcon from "../../../../../assets/icons/send.svg";
import emojiIcon from "../../../../../assets/icons/emoji.svg";
import anexoIcon from "../../../../../assets/icons/anexo_gray.svg";
import { SentEmails } from "./components/sent-emails";

export const Email = () => {
  const data = {
    message: [
      {
        user: "cliente",
        de: "mariasilva@contato.com",
        para: "cliqueup@cliqueup.com.br",
        assunto: "fatura",
        message:
          "Estou com minha fatura em atraso e gostaria de opções para uma negociação, podem entrar em contato comigo?",
        horario: "Hoje, 10:22",
      },
      {
        user: "cliente",
        de: "mariasilva@contato.com",
        para: "cliqueup@cliqueup.com.br",
        assunto: "fatura",
        message:
          "Estou com minha fatura em atraso e gostaria de opções para uma negociação, podem entrar em contato comigo?",
        horario: "Hoje, 10:22",
      },
      {
        user: "cliente",
        de: "mariasilva@contato.com",
        para: "cliqueup@cliqueup.com.br",
        assunto: "fatura",
        message:
          "Estou com minha fatura em atraso e gostaria de opções para uma negociação, podem entrar em contato comigo?",
        horario: "Hoje, 10:22",
      },
    ],
  };
  return (
    <div className="h-full w-full px-2 ">
      <div className="flex  h-[14%] items-center gap-2 ">
        <div className="my-2 flex w-full flex-col items-center text-sm">
          <div className="input-historico my-0.5 w-full text-xs">
            <span className="w-14 rounded-md bg-primary p-1 text-center font-semibold text-white">
              De:
            </span>
            <input type="text" className="input-email" />
          </div>
          <div className="input-historico my-0.5 w-full">
            <span className="w-14 rounded-md bg-primary p-1 text-center font-semibold text-white">
              Para:
            </span>
            <input type="text" className="input-email" />
          </div>
          <div className="input-historico my-0.5 w-full">
            <span className="w-14 rounded-md bg-primary p-1 text-center font-semibold text-white">
              Cc:
            </span>
            <input type="text" className="input-email" />
          </div>
          <div className="input-historico my-0.5 w-full">
            <span className="w-14  text-[11px] font-medium text-black underline">
              Assunto:
            </span>
            <input type="text" className="input-email" />
          </div>
        </div>

        <button className="h-full rounded-md bg-primary p-4">
          <img src={sendIcon} alt="" className="h-8 w-8" />
        </button>
      </div>

      <div className="my-4 flex h-32 w-full flex-col rounded-sm  bg-gray-200">
        <textarea
          className="h-full w-full resize-none  bg-transparent p-2 text-xs outline-none placeholder:text-gray-400 2xl:text-sm"
          placeholder="Escreva aqui..."
        />
        <div className="flex h-[34%] items-center justify-between  px-2">
          <button>
            <img src={emojiIcon} alt="" className="h-4" />
          </button>
          <button className="flex items-center gap-1 text-xs underline">
            Anexar arquivo
            <img src={anexoIcon} alt="" className="h-5" />
          </button>
        </div>
      </div>

      <hr
      // className=" h-0.5 w-full bg-gray-300"
      />

      <div className="my-2 flex h-full flex-col items-center">
        <strong className="mb-2 text-sm text-gray-600">Histórico</strong>
        <div className="max-h-[40%] overflow-y-auto overflow-x-hidden rounded border p-2">
          {data.message.map((message, i) => (
            <SentEmails email={message} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
